module.exports = __webpack_public_path__ + "img/the-cottages-sign.e96cb0e3.jpg";